<template>
  <div class="content-wrapper">
    <!-- 左侧区域树和异常设备 -->
    <div class="left-panel">
      <div class="panel-header">
        <el-tabs v-model="leftPanelActiveTab">
          <el-tab-pane label="区域选择" name="tree"></el-tab-pane>
          <el-tab-pane label="告警记录" name="abnormal"></el-tab-pane>
        </el-tabs>
      </div>

      <!-- 区域树内容 -->
      <div class="panel-content" v-show="leftPanelActiveTab === 'tree'">
        <div class="tree-container">
          <tree
            style="z-index: 9999"
            :props="{ label: 'name', children: 'areas' }"
            :data="treeList"
            @handleNodeClick="_leafSelect"
            :expanded="[1]"
            ref="region"
          />
        </div>
      </div>

      <!-- 异常设备内容 -->
      <div class="panel-content" v-show="leftPanelActiveTab === 'abnormal'">
        <div class="abnormal-device-content">
          <div class="ycmain">
            <!-- <div class="head">异常设备</div> -->
            <!-- <div class="headList">
              <span
                v-for="(i, index) in yichangHeadList"
                :key="index"
                :class="[
                  'headListmain',
                  `headList${index}`,
                  headlistNum === index ? `headlistActive${index}` : ``
                ]"
                @click="yc_headlist(index)"
                >{{ i.name }} {{ `(${i.num})` }}</span
              >
            </div> -->
            <div class="yccontent">
              <div
                :class="['row', `row${i.eventType}`]"
                v-for="(i, index) in ycData"
                :key="index"
                @click="jumppoint(i.regionId, i)"
              >
                <span>{{
                  i.eventType === "1"
                    ? "报警"
                    : "" || i.eventType === "2"
                    ? "故障"
                    : "" || i.eventType === "3"
                    ? "动作"
                    : "" || i.eventType === "4"
                    ? "屏蔽"
                    : ""
                }}</span>
                <span>{{ i.deviceName }}</span
                ><span>{{ i.createTime }}</span>
              </div>
              <el-pagination
                layout="prev, pager, next"
                :total="yctotal"
                class="ycPagination"
                @current-change="handleCurrentChange"
                :current-page="currPage"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧主内容区 -->
    <div class="main-content">
      <div
        :class="['statistics', treeActive === 0 ? 'expand' : 'hide']"
        v-if="deviceNumber && deviceNumber.list"
        v-show="treeActive === 0"
      >
        <div
          class="deviceApplication"
          v-for="(i, index) in deviceNumber.list"
          :key="index"
        >
          <div class="applicationImg">
            <span><i :class="'iconfont ' + i.icon"></i></span>
          </div>
          <div class="applicationTxt">
            <div class="applicationnNum">
              <i>{{ i.onlineCount }}</i>
              <i>/{{ i.counts }}</i>
            </div>
            <p>{{ i.name }}</p>
          </div>
        </div>
      </div>
      <!-- 地图、平面图、蜂鸟图 -->
      <section class="map" ref="map" @click.prevent.stop="hideLeftBar">
        <div class="mapBox">
          <mp
            v-if="rootData && model === 0"
            :data="rootData"
            :deviceType="deviceType"
            :systemId="systemId"
            @deviceInfo="deviceInfo"
          />
          <displays
            v-if="rootData && model === 1"
            :areaIds="areaId"
            :imgUrl="imgUrl"
            :initResult="rootData"
            :deviceType="deviceType"
            :systemId="systemId"
            :menuFlag="appId"
            @deviceInfo="deviceInfo"
            @showDetail="showDetail"
            ref="displays"
          />
          <feng-map
            v-if="mapId && model === 2"
            :areaId="areaId"
            :mapId="mapId"
            :themeId="themeId"
            :floorCount="floorCount * 1 || 1"
            :floorId="floorId * 1 || 1"
            :ctrlOffset="{ x: 200, y: 380 }"
            :areaType="areaType"
            :deviceType="filterDeviceTypeList"
            @showDetail="showDetail"
          />
        </div>
      </section>
      <!-- 设备详情信息框 -->
      <div class="detail" v-if="showDeviceDetail">
        <div class="closeDetail" @click.prevent.stop="_closeDetail">
          <i class="iconfont iconright"></i>
        </div>
        <header>
          <div class="title">
            {{ deviceList.deviceName }}
            <span :class="deviceList.status !== 1 ? 'iActive' : ''">
              <i></i>{{ deviceList.deviceStatusName }}
            </span>
          </div>
          <div class="detailContent">
            <div class="deviceIcon">
              <span
                ><i
                  :class="'iconfont ' + (deviceList.icon || 'iconweidingyi-')"
                ></i
              ></span>
            </div>
            <div>
              <p>
                设备编码：{{ deviceList.device_mark || deviceList.deviceId }}
              </p>
              <p>设备区域：{{ deviceList.region || deviceList.address }}</p>
            </div>
          </div>
        </header>
        
        <div class="device" v-if="deviceData">
          <div class="deviceList"  v-for="item in deviceData" :key="item">
            <div class="bg">{{ item.dataflowUnit }}</div>
            <h6>{{ item.dataflowName }}</h6>
            <p>{{ item.dataflowData }} {{ item.dataflowUnit }}</p>
          </div>
        </div>
        <div class="video" v-if="deviceList.description==='video'">
          <videoPlayer :videoUrl="url+deviceList.videoUrl" v-if="deviceList.videoUrl" :id="deviceList.id"></videoPlayer>
        </div>
        <div class="information" v-else>
          <el-tabs v-model="activeName">
            <el-tab-pane label="报警信息" name="first">
              <div class="searchTime">
                <el-date-picker
                  v-model="startTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="请选择开始时间"
                />
                -
                <el-date-picker
                  v-model="endTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择结束时间"
                />
                <div class="searchSubmit" @click.prevent.stop="_searchSubmit">
                  <i style="color: #2f82b7" class="el-icon-search"></i>
                </div>
              </div>
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="startTime" label="报警时间" width="180">
                </el-table-column>
                <el-table-column prop="alarmDesc" label="报警内容">
                </el-table-column>
                <el-table-column label="操作" width="100" align="left">
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.alarmStatus !== 4"
                      type="warning"
                      size="small"
                      >未处理</el-tag
                    >
                    <el-tag v-else type="success" size="small">已处理</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="事件信息" name="second">
              <div class="searchTime">
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="startTime1"
                  type="date"
                  placeholder="请选择开始时间"
                />
                -
                <el-date-picker
                  v-model="endTime1"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择结束时间"
                />
                <div class="searchSubmit" @click.prevent.stop="_searchSubmit1">
                  <i style="color: #2f82b7" class="el-icon-search"></i>
                </div>
              </div>
              <el-table :data="eventData" style="width: 100%">
                <el-table-column
                  prop="eventTypeName"
                  label="事件名称"
                  width="180"
                >
                </el-table-column>
                <el-table-column prop="eventContent" label="事件内容">
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!-- 空开设备详情弹窗 -->
      <switchDetail ref="switchDetail" :deviceList="deviceList"></switchDetail>
      <pointDetail ref="pointDetail" :deviceList="deviceList"></pointDetail>
      <!-- 烟火监测摄像设备详情弹窗 -->
      <cameraDetail ref="cameraDetail" :deviceList="deviceList"></cameraDetail>
    </div>
  </div>
</template>

<script>
import cameraDetail from "./cameraDetail/index.vue";
import switchDetail from "./switchDetail/index.vue";
import videoPlayer from "./camera/video";
export default {
  data() {
    return {
      leftPanelActiveTab: "tree",
      // 头部设备统计是否展开
      isOpen: true,
      // 设备统计数据
      deviceNumber: {},
      // 左边按钮栏数据
      treeData: [
        { id: 0, value: "区域" },
        { id: 1, value: "应用系统" },
        { id: 2, value: "设备类型" }
      ],
      yichangHeadList: [
        { name: "全部", prop: "unusual", num: "" },
        { name: "报警", prop: "alarm", num: "" },
        { name: "故障", prop: "fault", num: "" },
        { name: "动作", prop: "action", num: "" },
        { name: "屏蔽", prop: "shield", num: "" }
      ],
      ycData: [],
      yctotal: 1,
      currPage: 1,
      ClassDev: false,
      // 左边按钮栏选中索引
      treeActive: -1,
      // 左边区域树列表
      treeList: [],
      // 应用系统展示列表或图标标识
      showIcon: false,
      // 应用系统列表
      systemArr: [],
      // 应用系统选中索引
      iconListActive: -1,
      // 当前选中的应用系统ID
      systemId: null,
      // 设备类型展示列表或图标标识
      showIcon1: false,
      // 全部设备类型
      deviceTypeListAll: [],
      // 过滤设备类型列表
      deviceTypeList: [],
      // 过滤的设备类型ID
      filterDeviceTypeList: [],
      // 设备类型选中索引
      iconListActive1: -1,
      // 当前选中的设备类型ID
      deviceType: null,
      // 地图展现模式 0：平面图1：地图 2：蜂鸟图
      model: 0,
      // 地图数据
      rootData: [],
      // 平面图区域ID
      areaId: "",
      // 平面图图片地址
      imgUrl: "",
      // 蜂鸟图 地图编号
      mapId: "",
      // 蜂鸟图 主题编号
      themeId: "",
      // 蜂鸟图 楼层号
      floorId: "",
      // 蜂鸟图 楼层数
      floorCount: "",
      // 区域是否为安装点
      areaType: null,
      // 是否展示设备信息框
      showDeviceDetail: false,
      // 设备信息
      deviceList: {},
      // 设备详情最新的设备数据
      deviceData: [],
      // 设备详情选中事件或报警
      activeName: "first",
      // 报警查询开始时间
      startTime: "",
      // 报警查询结束时间
      endTime: "",
      // 事件查询开始时间
      startTime1: "",
      // 事件查询开始时间
      endTime1: "",
      // 报警信息列表
      tableData: [],
      // 事件信息列表
      eventData: [],
      headlistNum: 0,
      showApp: false,
      appId: "",
      _systemId: "",
      videoId:"",
      url:""
    };
  },
  components: {
    mp: () => import("./aMap"),
    search: () => import("./search"),
    tree: () => import("public/regionTree/tree"),
    displays: () => import("./displayb"),
    videoPlayer,
    switchDetail,
    pointDetail: () => import("./pointDetail"),
    cameraDetail
  },
  watch: {
    systemId(n, o) {
      let filterList = [];
      if (n && n > 0) {
        this.deviceTypeList = this.deviceTypeListAll.filter(
          it => it.systemId === n
        );
      } else {
        this.deviceTypeList = this.deviceTypeListAll;
      }
      this.deviceTypeList.forEach(t => {
        filterList.push(t.typeName);
      });
      this.filterDeviceTypeList = filterList;
    },
    deviceType(n, o) {
      if (n && n > 0) {
        this.filterDeviceTypeList = [
          this.deviceTypeList.find(it => it.id === n).typeName
        ];
      } else {
        let filterList = [];
        this.deviceTypeList.forEach(t => {
          filterList.push(t.typeName);
        });
        this.filterDeviceTypeList = filterList;
      }
    },
    $route: {
      handler(to, from) {
        console.log(to, "to");
        this.appId = to.name;
        this._getSys();
      },
      deep: true,
      immediate: true
    },
    isOpen: {
      handler(n, o) {
        if (n) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.isOpen = false;
            }, 10000);
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    _openVideo(id) {
        this.videoId = id
      },
    // 展开统计
    _open() {
      this.isOpen = !this.isOpen;
    },
    // 应用系统切换到列表
    _showListBox() {
      this.showIcon = true;
    },
    // 应用系统切换到图标
    _showIconList() {
      this.showIcon = false;
    },
    // 设备类型切换到列表
    _showListBox1() {
      this.showIcon1 = true;
    },
    // 设备类型切换到图标
    _showIconList1() {
      this.showIcon1 = false;
    },
    // 全部应用系统
    _checkSysAll() {
      this.iconListActive = -1;
      this.iconListActive1 = -1;
      this.deviceType = null;
      this.systemId = null;
      this._getDeviceNumber(this.areaId, null, null);
    },
    // 全部设备类型
    _checkDeviceAll() {
      this.iconListActive1 = -1;
      this.deviceType = null;
      this._getDeviceNumber(this.areaId, this.systemId, null);
    },
    // 左边按钮栏切换
    _treeClick(index) {
      this.treeActive = index === this.treeActive ? -1 : index;
      this.ClassDev = false;
      this.showApp = false;
    },
    // 区域树选择
    _leafSelect(e) {
      console.log(e, "-e-");
      this._getDeviceNumber(e.id, this.systemId, this.deviceType);
      this.showDeviceDetail = false;
      if (this.$refs.cameraDetail) {
        this.$refs.cameraDetail.closeDetail();
      }
      if (this.$refs.switchDetail) {
        this.$refs.switchDetail.closeDetail();
      }
      if (this.$refs.pointDetail) {
        this.$refs.pointDetail.closeDetail();
      }
      this.treeActive === 2 ? (this.showApp = true) : "";
      if (e.model === 0) {
        // 地图
        this.model = 0;
        this.rootData = [];
        if (e.areas !== null && e.areas && e.areas.length) {
          e.areas.forEach(item => {
            if (item.type === 1) {
              this.rootData.push(item);
            }
          });
        }
      } else if (e.model === 1) {
        // 平面图
        this.model = 1;
        this.imgUrl = e.url;
        this.areaId = e.id;
        this.rootData = [];
        if (e.areas !== null && e.areas & e.areas.length) {
          e.areas.forEach(item => {
            if (item.type === 1) {
              this.rootData.push(item);
            }
          });
        }
        console.log(e);
      } else if (e.model === 2) {
        // 蜂鸟
        this.model = 2;
        this.areaId = e.id;
        let mapId = e.mapNumber;
        mapId = mapId && "undefined" !== mapId ? mapId : null;
        this.mapId = mapId;
        let themeId = e.url;
        themeId = themeId && "undefined" !== themeId ? themeId : null;
        this.themeId = themeId;
        this.areaType = e.type;
        let floorCount = e.floorNumber;
        floorCount =
          floorCount && "undefined" !== floorCount ? floorCount : null;
        this.floorCount = floorCount ? floorCount * 1 : null;
        let floorId = e.dotNumber;
        floorId = floorId && "undefined" !== floorId ? floorId : null;
        this.floorId = floorId ? floorId * 1 : null;
      }
      if (this.rootData.length === 0) {
        this.rootData.push(e);
      }
    },
    // 应用系统选择
    _checkedSys(e, index) {
      this.ClassDev = true;
      let that = this;
      if (index === that.iconListActive) {
        that.iconListActive = -1;
        that.systemId = null;
      } else {
        that.iconListActive = index;
        that.systemId = e.id;
      }
      this.iconListActive1 = -1;
      that.deviceType = null;
      that._getDeviceNumber(that.areaId, that.systemId, that.deviceType);
      this.showDeviceDetail = false;
      if (this.$refs.cameraDetail) {
        this.$refs.cameraDetail.closeDetail();
      }
      if (this.$refs.switchDetail) {
        this.$refs.switchDetail.closeDetail();
      }
      if (this.$refs.pointDetail) {
        this.$refs.pointDetail.closeDetail();
      }
    },
    // 设备类型选择
    _checkDevice(e, index) {
      let that = this;
      if (index === that.iconListActive1) {
        that.iconListActive1 = -1;
        that.deviceType = null;
      } else {
        that.iconListActive1 = index;
        that.deviceType = e.id;
      }
      that._getDeviceNumber(that.areaId, that.systemId, that.deviceType);
      this.showDeviceDetail = false;
      if (this.$refs.cameraDetail) {
        this.$refs.cameraDetail.closeDetail();
      }
      if (this.$refs.switchDetail) {
        this.$refs.switchDetail.closeDetail();
      }
      if (this.$refs.pointDetail) {
        this.$refs.pointDetail.closeDetail();
      }
    },
    // 初始化区域树数据及地图数据
    initMapData() {
      this.$axiosget(`operation/area/selectArea?menuFlag=${this.appId}`).then(res => {
        this.treeList = res.data.data || [];
        this.rootData = res.data.data || [];
        if (res.data.data[0]) this._leafSelect(res.data.data[0]);
      });
    },
    // 应用系统
    _getSys() {
      this.$axiosget(
        "manager/operatingSystemApi/getOperatingSystemsByCompanyId",
        {
          params: {
            compayId: localStorage.getItem("companyId")
          }
        }
      ).then(res => {
        this.systemArr = res.data.data || [];
        const system = res.data.data.find(item => {
          return item.menuFlag == this.appId;
        });
        if (system) {
          this._systemId = system.id;
        }
        console.log(this._systemId, "this._systemId");

        console.log(this.systemArr);
        this.yc_headlist(0);
        // this.getYcDevNum();

        // console.log(this._systemId,'this._systemId');
      });
    },
    //设备类型
    _getDeviceType() {
      this.$axiosget("manager/devicetype/getTypeByCompanyId", {
        params: {
          companyId: localStorage.getItem("companyId")
        }
      }).then(res => {
        this.deviceTypeListAll = res.data.data || [];
        this.deviceTypeList = res.data.data || [];
      });
    },
    // 设备统计
    _getDeviceNumber(areaId, systemId, deviceTypeId) {
      let params = {
        companyId: localStorage.getItem("companyId"),
        areaId: areaId,
        menuFlag: this.appId,
        deviceTypeId: deviceTypeId
      };

      this.$axiosget("operation/area/countSystemDevice", { params }).then(
        res => {
          this.deviceNumber = res.data.data || [];
        }
      );
    },
    // 隐藏左侧筛选框
    hideLeftBar() {
      this.treeActive = -1;
      this.ClassDev = false;
      this.showApp = false;
    },
    // 地图或平面图设备信息
    deviceInfo(e) {
      console.log(e);
      if (e === "close") {
        this.showDeviceDetail = false;
        if (this.$refs.cameraDetail) {
          this.$refs.cameraDetail.closeDetail();
        }
        if (this.$refs.switchDetail) {
          this.$refs.switchDetail.closeDetail();
        }
        if (this.$refs.pointDetail) {
          this.$refs.pointDetail.closeDetail();
        }
      } else {
        if (e.description == "fireDetectionCamera") {
          this.deviceList = e;
          this.$refs.cameraDetail.checkDetail(e);
        } else if (e.description == "空开") {
          this.deviceList = e;
          this.$refs.switchDetail.checkDetail(e);
        } else if (e.description == "pointInspect") {
          this.deviceList = e;
          this.$refs.pointDetail.checkDetail(e);
        } else {
          this.deviceList = e;
          console.log(this.deviceList,'222222');
          
          this._deviceAlarm({ deviceId: this.deviceList.deviceId });
          this._deviceEvent();
          this.$axiosget(
            "taos/taosdata/query_latest?id=" + e.id + "&typeId=" + e.deviceType
          ).then(res => {
            this.deviceData = res.data.data || [];
          });
          this.showDeviceDetail = true;
        }
      }
    },
    showDetail(e){
      this.showDeviceDetail = e;
    },
    // 报警信息查询
    _deviceAlarm(params) {
      this.$axiospost(
        "operation/deviceAlarmApi/getAlarmNowPageList",
        params
      ).then(res => {
        this.tableData = res.data.data.list || [];
      });
    },
    // 报警信息搜索
    _searchSubmit() {
      let data = {
        startTime: this.startTime,
        endTime: this.endTime ? this.endTime + " 23:59:59" : "",
        deviceId: this.deviceList.device_mark
      };
      this._deviceAlarm(data);
    },
    // 事件信息查询
    _deviceEvent() {
      this.$axiosget(
        `extra/deviceEvent/page?deviceId=${this.deviceList.device_mark}`
      ).then(res => {
        this.eventData = res.data.data.list || [];
      });
    },
    // 事件信息搜索
    _searchSubmit1() {
      // let params = {
      //   startTime1: this.startTime1,
      //   endTime1: this.endTime1 ? this.endTime1 + " 23:59:59" : "",
      //   deviceId: val?val.deviceId:this.deviceList.device_mark,
      // };
      this.$axiosget(
        `extra/deviceEvent/page?startTime1=${this.startTime1}
      &endTime1=${this.endTime1 ? this.endTime1 + " 23:59:59" : ""}&deviceId=${
          this.deviceList.device_mark
        }`
      ).then(res => {
        this.eventData = res.data.data.list || [];
      });
    },
    // 关闭设备详情
    _closeDetail() {
      this.showDeviceDetail = false;
    },
    showList(i) {
      this.treeActive === -1 ? (this.treeActive = i) : (this.treeActive = -1);
    },
    getYcDevNum() {
      this.$axiosget("/operation/eventType/device/count", {
        params: { menuFlag: this.appId }
      }).then(res => {
        let {
          data: { data }
        } = res;
        this.yichangHeadList.forEach(i => {
          i.num = data[i.prop];
        });
      });
    },
    yc_headlist(i) {
      this.headlistNum = i;
      let num = this.headlistNum;
      num === 0 ? (num = -1) : "";
      this.bjdevice(num);
    },
    //报警设备
    bjdevice(num) {
      this.$axiosget("/operation/eventType/device/page", {
        params: { type: 1, menuFlag: this.appId }
      }).then(res => {
        let {
          data: {
            data: { list }
          }
        } = res;
        this.yctotal = res.data.data.total;
        this.ycData = list
      });
    },
    handleCurrentChange(val) {
      this.currPage = val;
      let num = this.headlistNum;
      num === 0 ? (num = -1) : "";
      this.$axiosget("/operation/eventType/device/page", {
        params: { type: 1, pageNum: val }
      }).then(res => {
        let {
          data: {
            data: { list }
          }
        } = res;

        this.ycData = list.filter(item => item.eventType === '1');
      });
    },
    //异常设备跳转点位
    jumppoint(val, i) {
      console.log(this.$refs.region.$refs.tree.getNode(val).data, "-------");
      console.log(this.appId, 1232131231312313);

      this._leafSelect(this.$refs.region.$refs.tree.getNode(val).data);
      let { id } = this.$refs.region.$refs.tree.getNode(val).data;
      this.$axiosget("/operation/areaParamater/devices", {
        params: { area_id: id, menuFlag: this.appId }
      })
        .then(res => {
          
          let deviceList = res.data.data[0].deviceList[0];
          console.log(deviceList,'111111');
          this.deviceInfo(deviceList);
        })
        .then(res => {
          if (Number(i.eventType) > 1) {
            this.activeName = "second";
          }
        });
    }
  },
  mounted() {
    console.log('enter');
    
    this.initMapData();
    // this._getSys()
    this._getDeviceType();
    this._getDeviceNumber();
    this.url=window.location.origin
  }
};
</script>

<style scoped lang="less">
// @keyframes _expand {
//   0% {
//     width: 0%;
//   }
//   20%{
//     width: 20%
//   }
//   40%{
//     width: 40%
//   }
//   60%{
//     width: 60%;
//   }
//   80%{
//     width: 80%;
//   }
//   100%{
//     width: auto;
//   }
// }
.content {
  height: 100%;
  .yichang {
    background: url("imgaes/yichangBg.png") no-repeat;
    width: 610px;
    height: 420px;
    position: absolute;
    left: 200px;
    top: 200px;
    z-index: 32;
    .ycmain {
      margin-left: 20px;
      margin-top: 20px;
      color: #fff;
      .head {
        width: 80%;
        line-height: 40px;
        font-size: 16px;
        padding-left: 10px;
        margin-left: 0;
        box-sizing: border-box;
        border-top: 1px solid transparent;
        border-bottom: 1px solid transparent;
        border-image: linear-gradient(
            to right,
            #196791cc 0%,
            rgba(35, 183, 203, 0) 66%
          )
          1 10;
        background: linear-gradient(to right, #123d5ecc 0%, #19668f00 66%);
        margin-left: 20px;
      }
      .headList {
        width: 80%;
        margin: 10px 0px 10px 24px;
        display: flex;
        justify-content: space-between;
        .headListmain {
          font-size: 14px;
          line-height: 20px;
          padding: 0px 6px;
          cursor: pointer;
        }
        .headList0 {
          color: #fff;
        }
        .headList1 {
          color: #f62e40;
        }
        .headList2 {
          color: #f2793e;
        }
        .headList3 {
          color: #1a71dd;
        }
        .headList4 {
          color: #b6b7b7;
        }
        .headlistActive0 {
          border: 1px solid #c1c6cb;
          background-color: #07182b;
          border-radius: 6px;
        }
        .headlistActive1 {
          border: 1px solid #cf0b1d;
          background-color: #410a0f;
          border-radius: 6px;
        }
        .headlistActive2 {
          border: 1px solid #a45b35;
          background-color: #372416;
          border-radius: 6px;
        }
        .headlistActive3 {
          border: 1px solid #1663be;
          background-color: #1f3b52;
          border-radius: 6px;
        }
        .headlistActive4 {
          border: 1px solid #757575;
          background-color: #494949;
          border-radius: 6px;
        }
      }
      .yccontent {
        width: 80%;
        margin-left: 24px;
        .row {
          font-size: 12px;
          line-height: 16px;
          padding: 4px 0;
          display: flex;
          justify-content: space-between;
          text-align: center;
          border-bottom: 1px dashed #536272;
          cursor: pointer;
          span:first-child {
            width: 80px;
          }
          span:last-child {
            width: 160px;
          }
        }
        .row1 {
          color: #f62e40;
        }
        .row2 {
          color: #f2793e;
        }
        .row3 {
          color: #1a71dd;
        }
        .row4 {
          color: #b6b7b7;
        }
        .ycPagination {
          margin-top: 0px;
          padding: 6px 0px;

          /deep/.el-pager li {
            font-size: 12px;
            min-width: 22px;
            height: 24px;
            line-height: 24px;
            font-weight: 10;
            color: #fff;
          }
        }
        /deep/.el-pagination .btn-next,
        /deep/.el-pagination .btn-prev {
          min-width: 22px;
          height: 24px;
          line-height: 24px;
          color: #fff;
        }
      }
    }
  }
}
.statistics {
  display: flex;
  position: absolute;
  z-index: 32;
  left: 200px;
  top: 20px;
  height: 125px;
  background: rgba(6, 15, 23, 0.48);
  border: 1px solid #152e42;
  overflow: hidden;
  .total {
    width: 120px;
    border-right: 1px solid #0f2231;
    text-align: center;
    cursor: pointer;
    .totalimg {
      margin: 10px auto 0;
      width: 70px;
      height: 70px;
      background: url("imgaes/total.png") no-repeat;
      background-size: cover;
    }
    .totalnum {
      color: #36bfff;
      width: 120px;
      font-size: 30px;
      line-height: 36px;
    }
  }
  .deviceApplication {
    min-width: 200px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    background: rgba(6, 15, 23, 0.1);
    border-right: 2px solid;
    border-image: -webkit-linear-gradient(transparent, #1c3b54, transparent) 0 1;
    border-image: -moz-linear-gradient(transparent, #1c3b54, transparent) 0 1;
    border-image: linear-gradient(transparent, #1c3b54, transparent) 0 1;
    .applicationImg {
      margin: 25px 10px 25px 0;
      line-height: 70px;
      span {
        display: inline-block;
        width: 60px;
        height: 60px;
        background: url("imgaes/electric.png") no-repeat;
        background-size: cover;
        line-height: 60px;
        text-align: center;
        vertical-align: middle;
        i {
          font-size: 24px;
          color: #00baff;
        }
      }
    }
    .applicationTxt {
      margin-top: 30px;
      min-width: 100px;
      .applicationnNum {
        font-family: fantasy;
        font-size: 30px;
        i {
          &:nth-of-type(1) {
            color: #01e794;
          }
          &:nth-of-type(2) {
            color: #00baff;
          }
        }
      }
      p {
        font-size: 12px;
        color: #fff;
      }
    }
  }
}
.statistics.expand {
  // animation: _expand 1s ease-in-out;
  // animation-fill-mode: forwards;
}
.statistics.hide {
  width: 120px !important;
}
.detail {
  width: 580px;
  padding: 10px 50px;
  position: absolute;
  z-index: 633;
  bottom: 30px;
  right: 20px;
  background: #0d1424d3;
  overflow: hidden;
  .detailContent {
    padding: 10px;
    display: flex;
    align-items: center;
    .deviceIcon {
      width: 50px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      background: url("imgaes/electric.png") no-repeat;
      background-size: contain;
      i {
        color: #00b9ff;
      }
    }
  }
  .closeDetail {
    position: absolute;
    left: 5px;
    top: 50%;
    z-index: 345;
    color: #36bfffb8;
    width: 30px;
    height: 30px;
    cursor: pointer;
    .iconright{
      font-size: 40px;
    }
  }
  header {
    .title {
      width: 100%;
      height: 40px;
      background: url("imgaes/detailHeaderBg.png") no-repeat;
      color: #ccc;
      font-size: 16px;
      padding-left: 15px;
      padding-top: 5px;
      span {
        color: #01ef99;
        float: right;
        i {
          margin-right: 5px;
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #01ef99;
        }
      }
      .iActive {
        color: #ef0101;
        i {
          background-color: #ef0101;
        }
      }
    }
    p {
      padding-left: 20px;
      color: #cacaca;
      font-size: 14px;
      line-height: 40px;
    }
  }
  .device {
    padding-left: 10px;
    display: flex;
    .deviceList {
      border: 1px solid #172839;
      width: 120px;
      margin-right: 10px;
      .bg {
        text-align: center;
        font-size: 20px;
        line-height: 50px;
        color: #00b9ff;
        margin: 10px auto 0;
        width: 50px;
        height: 50px;
        background: url("imgaes/electric.png") no-repeat;
        background-size: contain;
      }
      h6 {
        line-height: 30px;
        color: #61a1c3;
        text-align: center;
      }
      p {
        text-align: center;
        background: #042236;
        color: #126d9c;
        height: 35px;
        line-height: 35px;
      }
    }
  }
  .information {
    .searchTime {
      height: 60px;
      margin: 15px 0;
      padding: 10px;
      background: #1926435e;
      .searchSubmit {
        display: inline-block;
        width: 40px;
        height: 40px;
        border-radius: 50px;
        background-color: #283b65;
        text-align: center;
        line-height: 40px;
      }
    }
  }
  .video{
    height: 40vh;
  }
  /deep/ .el-input__prefix {
    line-height: 40px;
  }
  /deep/ .el-table {
    height: 400px;
    background: #0d14240a;
  }
  /deep/ .el-table__body-wrapper {
    max-height: 200px;
    overflow: scroll;
    background-color: #0d142410;
  }
  .el-tag.el-tag--warning {
    color: #f67516;
    border: 1px solid #f67516;
    background: #3d2522;
  }
  .el-tag.el-tag--success {
    background: #0b0e1d;
    border: 1px solid #314081;
    color: #314081;
  }
  /deep/.el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 188px;
    color: #00b8f7;
  }
  /deep/ .el-input__inner {
    background-color: #141f3618;
    border-color: #253658;
  }
  /deep/ .el-tabs__nav-wrap::after {
    background-color: #161f32;
  }
  /deep/ .el-tabs__header {
    color: #218dd1;
  }
  /deep/ .el-tabs__item.is-active {
    border-bottom: #35b9f7;
  }
  /deep/ .el-table th {
    background: #1926431c;
    color: #35b9f7;
  }
  /deep/ .el-table tr {
    background: #0d15252a;
    color: #98a6c5;
  }
  /deep/.el-table td {
    border-bottom: 1px dashed #ccc;
  }
}
.leftTree {
  position: absolute;
  z-index: 233;
  top: 40px;
  left: 40px;
  .deviceCount {
    font-size: 26px;
    font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    background-image: -webkit-linear-gradient(left, #fff, #749fff, #2165ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .ycCount {
    font-size: 26px;
    font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    background-image: -webkit-linear-gradient(left, #fff, #ff8879, #ff4b4b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  ul {
    li {
      color: #cccccc;
      cursor: pointer;
      width: 130px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: url("imgaes/treebg.png") no-repeat;
      margin-bottom: 20px;
    }
    .treeActive {
      color: #00bfff;
    }
  }
  .tree {
    width: 150px;
    height: 150px;
    position: relative;
    display: flex;
    align-items: center;
  }
  .tree:hover {
    cursor: pointer;
  }
  .tree0 {
    background: url("imgaes/zongshu.png") no-repeat center;
  }
  .tree1 {
    background: url("imgaes/yichang.png") no-repeat center;
  }
  .tree2 {
    background: url("imgaes/quyu.png") no-repeat center;
  }
}
.list {
  position: absolute;
  z-index: 233;
  top: 360px;
  left: 200px;
  max-height: 600px;
  // overflow: scroll;
  > ul {
    display: flex;
  }
  .nav {
    color: #cccccc;
    padding: 0 20px;
    height: 50px;
    background-image: linear-gradient(#062840, #004c78);
    text-align: right;
    line-height: 50px;
    div {
      display: inline-block;
      float: left;
    }
    .allList {
      float: left;
      i {
        margin-right: 10px;
      }
    }
    span {
      display: inline-block;
      font-size: 18px;
      width: 20px;
      line-height: 20px;
      text-align: center;
      color: #1f83e5;
      margin-right: 10px;
    }
    .spanActive {
      color: #6f7275;
    }
  }
  .application {
    width: 280px;
    min-height: 200px;
    height: 50vh;
    background: #02192acf;
    box-sizing: border-box;
    box-shadow: 0px 1px 15px rgb(49 152 255) inset;
    margin-right: 10px;
    .listBox {
      max-height: 450px;
      overflow-y: scroll;
      box-sizing: border-box;
      padding: 56px 20px 20px;
      li {
        display: flex;
        align-items: center;
      }
      .text {
        max-width: 200px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .activeLi {
        background-color: #0f4b85;
        color: #00b8f7;
      }
      li {
        color: #c3c3c3;
        line-height: 40px;
        margin-bottom: 10px;
        cursor: pointer;
        input {
          margin-right: 10px;
        }
        .box {
          display: inline-block;
          width: 13px;
          height: 13px;
          vertical-align: middle;
          background: #fff;
          border-radius: 3px;
          margin: 0 10px 0 0;
          margin-left: 20px;
        }
        .boxChecked {
          background: #1f83e5;
        }
      }
    }
    .iconList {
      padding: 20px;
      max-height: 500px;
      overflow: scroll;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        border: 1px solid #324c60;
        position: relative;
        width: 100px;
        height: 100px;
        margin: 10px;
        overflow: hidden;
        span {
          display: none;
          position: absolute;
          top: 0;
          right: 0;
          width: 0;
          height: 0;
          border: 12px solid;
          border-color: #6fafd9 #6fafd9 transparent transparent;
          i {
            position: absolute;
            top: -13px;
            left: -3px;
          }
        }
        div {
          background: url("imgaes/electric.png");
          width: 45px;
          margin: 15px auto 10px;
          height: 45px;
          text-align: center;
          line-height: 45px;
          i {
            color: #00b6fb;
          }
        }
        p {
          color: #61a1c3;
          font-size: 12px;
          background: #042236;
          line-height: 30px;
          width: 100%;
          text-align: center;
        }
      }
      .iconListActive {
        border-color: #5991b6;
        p {
          background: #163e5e;
          color: #fff;
        }
        span {
          display: inline-block;
        }
      }
    }
  }
  /deep/.el-radio__inner {
    border-radius: 2px;
  }
}
.map {
  width: 100%;
  height: 100%;
  position: relative;
  opacity: 1;
  display: flex;
  .mapBox {
    width: 100%;
    height: 100%;
    .searchBox {
      width: 316px;
      height: 42px;
      position: absolute;
      left: 30px;
      top: 30px;
      z-index: 3;
      border-radius: 3px;
      box-shadow: 2px 2px 15px #d4d4d4;
    }
  }
}
/* 新的布局样式 */
.content-wrapper {
  display: flex;
  height: calc(100% - 20px);
  width: 100%;
  margin-top: 20px;
}

.left-panel {
  width: 15%;
  padding: 0px 0px;
  height: calc(100% - 20px);
  overflow: auto;
  outline: 1px solid #323d55;
  /deep/ .el-tabs__item {
    color: #fff;
  }
  /deep/.el-tabs__item.is-active {
    color: #409eff;
  }
}

.panel-header {
  padding: 0;
  background: linear-gradient(to right, #0c253d, #081b2e);
  border-bottom: 1px solid #152e42;
  /deep/ .el-tabs__nav {
    width: 100%;
  }
  /deep/ .el-tabs__item {
    flex: 1;
    text-align: center;
    color: #a0c2d8;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    width: 50%;
    box-sizing: border-box;
  }
}

.panel-header ::v-deep .el-tabs__item.is-active {
  color: #36bfff;
}

.panel-header ::v-deep .el-tabs__active-bar {
  background-color: #36bfff;
  height: 2px;
}

.panel-header ::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent;
}

.panel-content {
  flex: 1;
  overflow-y: auto;
  height: 100%;
}

.tree-container {
  height: 100%;
}

.abnormal-device-content {
  height: 100%;
}

.ycmain {
  color: #fff;
}

.ycmain .head {
  width: 100%;
  line-height: 40px;
  font-size: 16px;
  padding-left: 10px;
  box-sizing: border-box;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-image: linear-gradient(
      to right,
      #196791cc 0%,
      rgba(35, 183, 203, 0) 66%
    )
    1 10;
  background: linear-gradient(to right, #123d5ecc 0%, #19668f00 66%);
}

.ycmain .headList {
  width: 100%;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.headListmain {
  font-size: 14px;
  line-height: 20px;
  padding: 4px 8px;
  cursor: pointer;
  margin-bottom: 5px;
}

.headList0 {
  color: #fff;
}

.headList1 {
  color: #f62e40;
}

.headList2 {
  color: #f2793e;
}

.headList3 {
  color: #1a71dd;
}

.headList4 {
  color: #b6b7b7;
}

.headlistActive0 {
  border: 1px solid #c1c6cb;
  background-color: #07182b;
  border-radius: 6px;
}

.headlistActive1 {
  border: 1px solid #cf0b1d;
  background-color: #410a0f;
  border-radius: 6px;
}

.headlistActive2 {
  border: 1px solid #a45b35;
  background-color: #372416;
  border-radius: 6px;
}

.headlistActive3 {
  border: 1px solid #1663be;
  background-color: #1f3b52;
  border-radius: 6px;
}

.headlistActive4 {
  border: 1px solid #757575;
  background-color: #494949;
  border-radius: 6px;
}

.yccontent {
  width: 100%;
  margin-top: 10px;
}

.row {
  font-size: 12px;
  line-height: 16px;
  padding: 6px 0;
  display: flex;
  justify-content: space-between;
  text-align: center;
  border-bottom: 1px dashed #536272;
  cursor: pointer;
}

.row span:first-child {
  width: 60px;
  flex-shrink: 0;
}

.row span:nth-child(2) {
  flex: 1;
  text-align: left;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row span:last-child {
  width: 120px;
  flex-shrink: 0;
}

.row1 {
  color: #f62e40;
}

.row2 {
  color: #f2793e;
}

.row3 {
  color: #1a71dd;
}

.row4 {
  color: #b6b7b7;
}

.ycPagination {
  margin-top: 10px;
  text-align: center;
}

.ycPagination ::v-deep .el-pager li {
  font-size: 12px;
  min-width: 22px;
  height: 24px;
  line-height: 24px;
  font-weight: 10;
  color: #fff;
}

.ycPagination ::v-deep .el-pagination .btn-next,
.ycPagination ::v-deep .el-pagination .btn-prev {
  min-width: 22px;
  height: 24px;
  line-height: 24px;
  color: #fff;
}

.main-content {
  flex: 1;
  height: 100%;
  position: relative;
  overflow: hidden;
}

/* 调整原有样式 */
.statistics {
  left: 170px;
  top: 20px;
}

.leftTree {
  left: 20px;
  top: 40px;
}

.list {
  left: 200px;
  top: 360px;
}

.map {
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  margin: 0 10px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .left-panel {
    width: 250px;
  }
}

@media (max-width: 992px) {
  .content-wrapper {
    flex-direction: column;
  }

  .left-panel {
    width: 100%;
    height: 300px;
    border-right: none;
    border-bottom: 1px solid #152e42;
  }

  .main-content {
    height: calc(100% - 300px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/lv2/appMonitor/firefightingEquipment.vue